export default __webpack_public_path__ + "static/media/green-circle2.ac562f5b.svg";